import React from "react";
import Logo2 from "../images/logo pic.png" 
import { withRouter } from "react-router-dom";
import "../App.css";
import "../css/bootstrap.css"
import "../css/styles.css"
import Logo from "../images/logo text.png" 
import Logo1 from "../images/team.jpg"
import Logo3 from "../images/logo pic.png" 
import Logo12 from "../images/logo12.png"
import app from "../base";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useContext, useState} from "react";
import { AuthContext } from "../Auth.js";
import Poster12 from "../images/pos13.png"
import EIPCAmem from "../images/EIPCAmember.jpg"

const About = ({history}) => {
  
  const { currentUser } = useContext(AuthContext);

  const Signout = () => {
    app.auth().signOut();
    history.push("/")
    window.location.reload(true)
    
  };
  


  return (
    
    <>
   

   <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="#service">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="#EIPCAnews">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


  {/* Header */}
  <br/>
  <br/>
  <br/>
  {/* end of header */}
  {/* <img class="img5" src="https://i.pinimg.com/564x/33/55/7f/33557fe576b6c183abe4b40352951162.jpg" height="2000"  alt="alternative"> */}
  {/* end of header */}
  {/* Details 1 */}
  <div className="basic-4">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="text-container">
            <h6 className="text-secondary text-uppercase font-weight-medium mb-3">
              Learn About Us
            </h6>
            <h1 className="" font-color="#ffffff">
              {" "}
              EIPCA
            </h1>
            <h5 className="font-weight-medium font-italic mb-4">
              Electrocardiogram Interpretation Pattern for Symptom Predictions
              of Arrythmia.
            </h5>
            <p className="mb-2 font-face-gl">
              
EIPCA is an application designed to aid in the rapid screening of sudden cardiac arrest (ventricular fibrillation) caused by irregular heart rhythms, utilizing artificial intelligence to analyze electrocardiogram waveforms. It serves as an app that helps screen a group of symptoms, shortens the diagnosis time for the disease, and addresses the issue of a shortage of experts.{" "}
            </p>
          </div>{" "}
          {/* end of text-container */}
        </div>{" "}
        {/* end of col */}
        <div className="col-lg-6">
          <div className="image-container">
            <img
              className="img-fluid" style={{borderRadius: "10px"}}
              src={Logo12}
              alt="alternative"
            />
          </div>{" "}
          {/* end of image-container */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of basic-4 */}
  {/* end of details 1 */}
  {/* Details 2 */}
  <div className="basic-5 bg">
    <div className="container ">
      <div className="row">
        <div className="col-lg-6">
          <div className="image-container">
            <img
              className="img-fluid" style={{borderRadius: "10px"}}
              src={EIPCAmem}
              alt="alternative"
            />
          </div>{" "}
          {/* end of image-container */}
        </div>{" "}
        {/* end of col */}
        <div className="col-lg-6">
          <div className="text-container">
            <h6 className="text-secondary text-uppercase font-weight-medium mb-3">
              Our Features
            </h6>
            <h1 className="mb-4 font-face-gm">Why EIPCA</h1>
            <p className="font-face-gl">
            EIPCA is a developed tool for screening and assessing the risk of sudden cardiac arrest from irregular heart rhythms by reading and analyzing abnormal electrocardiogram waveforms using artificial intelligence technology and standardized risk assessment criteria. It aims to enable healthcare professionals, researchers, nurses, hospitals, and related healthcare organizations to perform faster and more accurate examinations and treatments, ultimately reducing the chances of fatalities from heart and vascular diseases.
            </p>
            <div className="row"></div>
          </div>{" "}
          {/* end of text-container */}
        </div>{" "}
        
        {/* end of col */}
      </div>{" "}
      
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
    
  </div>{" "}
  {/* end of basic-5 */}
  {/* end of details 2 */}
  <div className="basic-4">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="text-container">
            {/* <h6 className="text-secondary text-uppercase font-weight-medium mb-3">
            Our co-opertion
            </h6> */}
            <h1 className="" font-color="#ffffff">
              {" "}
              Our Co-operation
            </h1>
            <h5 className="font-weight-medium font-italic mb-4">
              
            </h5>
            <p className="mb-2 font-face-gl">
            EIPCA has collaborated with the Faculty of Medicine, Chiang Mai University, to conduct testing and comparison of the EIPCA hardware with the cardiac waveform measuring device at Maharaj Nakorn Chiang Mai Hospital. The results showed that EIPCA achieved an impressive accuracy rate of up to 90% when compared to actual ECG devices.
            </p>
          </div>{" "}
          {/* end of text-container */}
        </div>{" "}
        {/* end of col */}
        <div className="col-lg-6">
          <div className="image-container">
            <img
              className="img-fluid" style={{borderRadius: "10px" , MarginRight: "100px"}}
              src={Poster12}
              alt="alternative"
            />
          </div>{" "}
          {/* end of image-container */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of basic-4 */}
  {/* end of details 1 */}

  
  
  
  


  
  {/* footer */}
  <div className="footer bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="footer-col first">
            <h6 className="font-face-gm">About EIPCA</h6>
            <p className="p-small font-face-gl">
            EIPCA stands for Electrocardiogram Interpretation Pattern for Symptom Predictions of Arrhythmia, a program aimed at assisting in the screening of sudden cardiac arrest (sudden death) caused by irregular heart rhythms through the analysis of electrocardiogram waveforms using artificial intelligence.
            </p>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col second font-face-gm">
            <h6 className="font-face-gm">Contact Us</h6>
            <ul className="list-unstyled li-space-lg p-small font-face-gl">
              <p>
                <i className="fa fa-map-marker-alt mr-2" />
                EIPCA Team 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                093-2789556 , 081-2895915 , 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                065-3595514
              </p>
              <p>
                <i className="fa fa-envelope mr-2" />
                EIPCAhackathon@gmail.com
              </p>
            </ul>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col third font-face-gm">
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-facebook-f fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-twitter fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-pinterest-p fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-instagram fa-stack-1x" />
              </a>
            </span>
            <p className="p-small">
              We would love to hear from you{" "}
              <a href="">
                <strong>EIPCA@gmail.com</strong>
              </a>
            </p>
          </div>{" "}
          {/* end of footer-col */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of footer */}
 
 
  




      
    </>
  );
};

export default withRouter(About);